import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

/**
 * Commponent for tables
 */
@Component({
  selector: '[app-table]',
  templateUrl: './table.component.html',
})
export class TableComponent implements OnInit, OnDestroy {
  @Input() public columns: Array<string> = [];
  @Input() public keys: Array<string> | any = [];
  @Input() public data: Array<any> = [];
  @Input() public limitResults: number;
  @Input() public actionButtons: Array<any> = [];
  @Input() public selectableTable: boolean = false;
  @Input() public smallTable: boolean = false;

  @Output() public rowClickEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() public rowButtonClickEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void { }

  /**
   * Triggers when row is clicked
   */
  public rowClicked(element: any): void {
    this.rowClickEvent.emit(element);
  }

  /**
   * Triggers when row button is clicked
   */
  public rowButtonClick(element: any): void {
    this.rowButtonClickEvent.emit(element);
  }

  public checkSelected(): string {
    let result = '';
    result = this.data.every(el => el.selected) ? 'all' : 'not-all';
    if (result === 'not-all') {
      result = this.data.some(el => el.selected) ? 'partial' : 'none';
    }
    return result;
  }

  public setAllSelected(): void {
    const currentlySelected = this.checkSelected();
    for (const el of this.data) {
      if (currentlySelected === 'all') {
        el.selected = false;
      } else {
        el.selected = true;
      }
    }
  }

}
